import {ActivityItemType} from '@toolify/server/src/models/mongoose/ActivityItemModel/enum/ActivityItemType'
import {useActivityItemSocketListener} from '@toolify/client/src/composables/useActivityItemSocketListener'
import {useStatusApiStore} from '@toolify/client/src/stores/api/StatusApiStore/useStatusApiStore'
import {useLabelApiStore} from '@toolify/client/src/stores/api/LabelApiStore/useLabelApiStore'

const STATUS_ACTIVITY_TYPES = [
  ActivityItemType.StatusCreated,
  ActivityItemType.StatusUpdated,
  ActivityItemType.StatusDeleted,
]

const LABEL_ACTIVITY_TYPES = [
  ActivityItemType.LabelCreated,
  ActivityItemType.LabelUpdated,
  ActivityItemType.LabelDeleted,
]

export function useReferenceDataCacheInvalidation(): void {
  const statusApiStore = useStatusApiStore()
  const labelApiStore = useLabelApiStore()

  for(const activityItemType of STATUS_ACTIVITY_TYPES) {
    useActivityItemSocketListener(activityItemType, () => {
      statusApiStore.invalidateStatusesCache()
    })
  }

  for(const activityItemType of LABEL_ACTIVITY_TYPES) {
    useActivityItemSocketListener(activityItemType, () => {
      labelApiStore.invalidateLabelsCache()
    })
  }
}
